import * as React from 'react'
import { Panel } from 'react-bootstrap';
import * as ReactHighcharts from 'react-highcharts'
const HighchartsMore = require('highcharts/highcharts-more')
HighchartsMore(ReactHighcharts.Highcharts)

interface IPanelGraphProps {
  title: string
  loading: boolean
  chartConfig: any
}

class PanelGraph extends React.Component<IPanelGraphProps, {}> {
  componentDidMount() {
    ReactHighcharts.Highcharts.setOptions({
      lang: {
        thousandsSep: ','
      }
    })
  }

  render() {
    const { title, loading, chartConfig } = this.props
    return (
      <Panel>
        {title && title !== '' &&
          <div className="panel-heading text-center">
            {title}{loading && <i className="fa fa-cog fa-spin"></i>}
          </div>
        }
        <div className="panel-body">
          <ReactHighcharts config={chartConfig} ref="chart" />
        </div>
      </Panel>
    )
  }
}

export default PanelGraph;


// WEBPACK FOOTER //
// ./src/app/components/tabs/PanelGraph/index.tsx